<script setup>
import UsersTable from "./users/UsersTable.vue";
import UserDetails from "./users/UserDetails.vue";
import { computed, onMounted, ref, watch } from "vue";
import { playerStatsService } from "@/apps/player/services/player-stats.service";
import { useRoute } from "vue-router";
import { useAsyncState } from "@vueuse/core";
import UsersStats from "@/apps/player/panel/users/UsersStats.vue";
import PanelSearch from "@/apps/player/panel/PanelSearch.vue";
import { usePagination } from "@/shared/utils/usePagination";
import { DATE_RANGE_MAPPER } from "@/apps/player/panel/lessons/date-range";

const showDetails = ref(false);
const userToShow = ref({});
const dateRange = ref(DATE_RANGE_MAPPER.all().queryFor);

const { params } = useRoute();
const playerUUID = computed(() => params.projectUuid);
// const pagination = reactive({ page, pageSize });

const { updatePaginationUnwrapResult, page, pageSize, totalPages } = usePagination({
    size: 100,
    fetchAction: () => reloadStudentList(),
});
const search = ref("");
const {
    state: studentList,
    execute: reloadStudentList,
    isLoading,
} = useAsyncState(
    () =>
        playerStatsService
            .getStudents(playerUUID.value, {
                page: page.value,
                size: pageSize.value,
                dateRange: dateRange.value,
                search: search.value,
            })
            .then(updatePaginationUnwrapResult),
    [],
    {
        immediate: false,
    }
);

const {
    state: studentLessonsDetails,
    execute: callStudentLessonsDetails,
    isLoading: areLessonsLoading,
} = useAsyncState(
    ({ playerUUID, userUUID } = {}) =>
        playerStatsService.getLessonsProgressForStudent(playerUUID, userUUID),
    [],
    {
        immediate: false,
    }
);

onMounted(async () => reloadStudentList());
watch([search], (value, oldValue) => {
    if (value !== oldValue) {
        reloadStudentList();
    }
});

const selectUser = async (student) => {
    userToShow.value = student;
    showDetails.value = true;
    const { userUUID } = student;
    if (userUUID) {
        await callStudentLessonsDetails(0, { playerUUID: playerUUID.value, userUUID });
    } else {
        studentLessonsDetails.value = [];
    }
};
</script>

<template>
    <UsersStats v-model:pageSize="pageSize" v-model:dateRange="dateRange" />

    <PanelSearch
        v-model="search"
        :placeholder="$t('player.panel.users.search')"
        :linkToPlayer="`/players/${playerUUID}`"
    />

    <UsersTable
        v-model:currentPage="page"
        :isLoading="isLoading"
        :searchQuery="search"
        :totalPages="totalPages"
        :users="studentList"
        @select="selectUser"
    />
    <UserDetails
        v-if="showDetails"
        @hide="showDetails = false"
        :user="userToShow"
        :lessons="studentLessonsDetails"
        :isLoading="areLessonsLoading"
    />
</template>
